<div class="carousel">
  <ng-container>
    <button
      tabindex="0"
      class="carousel-button previous-button"
      [disabled]="prevButtonDisabled()"
      (click)="prev()">
      <div class="button-img" tabindex="-1">
        <rd-shared-icon
          class="previous-arrow flippable-icon flippable-icon-ltr"
          [iconSymbol]="'icon-chevron-right'"
          [iconTheme]="'primary'"
          [iconOptions]="flippableIconOptions"></rd-shared-icon>
      </div>
    </button>
  </ng-container>

  <section class="carousel-wrapper">
    <ul class="carousel-inner" #carousel>
      <li
        *ngFor="let item of items"
        class="carousel-inner-item-container carousel-item">
        <ng-container [ngTemplateOutlet]="item.tpl"></ng-container>
      </li>
    </ul>
  </section>

  <ng-container>
    <button
      tabindex="0"
      class="carousel-button next-button"
      [disabled]="nextButtonDisabled()"
      (click)="next()">
      <div class="button-img" tabindex="-1">
        <rd-shared-icon
          class="next-arrow flippable-icon"
          [iconSymbol]="'icon-chevron-right'"
          [iconTheme]="'primary'"></rd-shared-icon>
      </div>
    </button>
  </ng-container>
</div>
